const futuresTabs = {
  grainsOilseeds: "Grains & Oilseeds",
  livestock: "Livestock",
  softs: "Softs",
  energies: "Energies",
  currencies: "Currencies",
};

export default futuresTabs;
